<template>
  <el-card>
    <section>
      <el-col :span="24">
        <div>
          <el-form size="small" :inline="true">
            <el-form-item>
              <el-button type="primary" @click="handleAdd">新增</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>

      <!--列表-->
      <template>
        <el-table border :data="newsList" highlight-current-row v-loading="loading" style="width: 100%;">
          <el-table-column type="index" width="60">
          </el-table-column>
          <el-table-column prop="name" label="内容名称" sortable>
          </el-table-column>
          <el-table-column prop="dictKey" label="内容标识" sortable>
          </el-table-column>
          <el-table-column prop="createDate" label="创建日期" sortable>
          </el-table-column>
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button class="btn-text-pd0" size="mini" type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!--工具条-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="padding: 15px 5px">
      </el-pagination>

      <el-dialog :title="title" :visible.sync="formVisible" :close-on-click-modal="false"  :before-close="cancelForm">
        <el-form :model="form" :rules="formRules" label-width="80px" ref="form" >
          <div style="padding-top: 10px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="内容名称" prop="name">
                  <el-input v-model="form.name" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="内容标识" prop="dictKey">
                  <el-input type="number" v-model="form.dictKey" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click.native="cancelForm">取消</el-button>
          <el-button size="medium" type="primary" @click.native="formSubmit" :loading="formLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </el-card>
</template>
<script>
/* eslint-disable */
import { doPost } from '../../api/api'
export default {
  data () {
    return {
      filters: {
      },
      loading: false,
      newsList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      form:{
        id:'',
        name: '',                        //所属类型
        dictType: 'region_department ', //分类名称
        dictKey: '',                    //分类标识
        value1: 1,                      //首次天数
        value2: '',                     //二次天数
      },
      formVisible: false,
      title: '',
      formRules: {
        name: [
          {required: true, message: '请输入内容名称', trigger: 'blur'}
        ],
        dictKey: [
          {required: true, message: '请输入内容标识', trigger: 'blur'},
          { pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/, message: '格式错误，请输入正数数字!', trigger: 'change' }
        ]
      },
      formLoading: false,
      user:{},
    }
  },
  methods: {
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.getPgaeList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getPgaeList()
    },
    //点击取消(处理规则校验)
    cancelForm(){
      this.formVisible = false
      this.$refs['form'].resetFields()
    },
    // 获取列表（查询条件，欠缺调整）
    getPgaeList: function () {
      this.loading = true
      let para = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        dictType: 'region_department '
      }
      doPost('/sysDict/getPageList', para).then(res => {
        this.newsList = res.result.list
        this.total = res.result.total
      })
      this.loading = false
    },
    // 显示新增界面
    handleAdd: function () {
      Object.assign(this.$data.form, this.$options.data().form)
      this.formVisible = true
    },
    //编辑
    handleEdit:function (id) {
      this.title = '编辑'
      this.formVisible = true
      let para = {
        id: id
      }
      doPost('/sysDict/getById',para).then(res =>{
        this.form = res.result
        delete this.form.updateDate
        delete this.form.createDate
        console.log(this.form)
      })
    },
    //提交
    formSubmit:function () {
      delete this.form.uploadStr
      console.log(this.form)
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗', '提示', {
            confirmButtonText: '继续提交',
            cancelButtonText: '取消'
          }).then(() => {
            this.formLoading = true
            let para = Object.assign({}, this.form)
            doPost('/sysDict/saveOrUpdate', para).then((res) => {
              this.formLoading = false
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.$refs['form'].resetFields()
              this.formVisible = false
              this.getPgaeList()
            })
          })
        }
      })
    }
  },
  mounted () {
    var user = JSON.parse(sessionStorage.getItem('user'))
    console.log(user)
    this.getPgaeList()
  }
}

</script>

<style scoped>

</style>
